export type PathAudioZone = 'NEON' | 'GOLD' | 'ICE' | 'DARK' | 'CRYSTAL' | 'FIRE';
export type AudioScene =
  | 'menu'
  | 'arena'
  | 'duel'
  | 'result'
  | 'club'
  | 'store'
  | 'path-neon'
  | 'path-gold'
  | 'path-ice'
  | 'path-dark'
  | 'path-crystal'
  | 'path-fire'
  | 'path-boss';

export function resolveAudioScene(pathname: string): AudioScene {
  if (pathname.startsWith('/game/duel') || pathname.startsWith('/duel')) return 'duel';
  if (pathname.startsWith('/path/game/')) return 'path-neon';
  if (pathname.startsWith('/game')) return 'arena';
  if (pathname.startsWith('/result')) return 'result';
  if (pathname.startsWith('/club')) return 'club';
  if (pathname.startsWith('/store')) return 'store';
  return 'menu';
}

export function resolvePathAudioScene(zone: PathAudioZone, nodeType: string): AudioScene {
  if (nodeType === 'BOSS' || nodeType === 'MILESTONE') return 'path-boss';
  return `path-${zone.toLowerCase()}` as AudioScene;
}

const dynamicScene = (scene: AudioScene): boolean =>
  scene === 'arena' || scene === 'duel' || scene.startsWith('path-');

export function calculateGameIntensity(input: {
  readonly occupiedCells: number;
  readonly score: number;
  readonly bestScore: number;
  readonly remainingPieces: number;
  readonly terminal: boolean;
}): number {
  if (input.terminal) return 1;
  const boardPressure = Math.min(1, Math.max(0, (input.occupiedCells - 20) / 38));
  const recordPressure =
    input.bestScore > 0 && input.score < input.bestScore
      ? Math.min(1, input.score / input.bestScore)
      : input.score >= input.bestScore && input.bestScore > 0
        ? 0.85
        : 0;
  const trayPressure = input.remainingPieces === 1 ? 0.12 : 0;
  return Math.min(1, Math.max(0, boardPressure * 0.68 + recordPressure * 0.2 + trayPressure));
}

export function musicInterval(scene: AudioScene, intensity: number): number {
  const clamped = Math.min(1, Math.max(0, intensity));
  if (dynamicScene(scene)) return Math.round(4_800 - clamped * 1_900);
  if (scene === 'result') return 6_200;
  if (scene === 'store') return 5_800;
  if (scene === 'club') return 5_600;
  return 6_400;
}
